import React, { useEffect, useRef } from 'react';

import { useApplicationBuildContext } from '@context/ApplicationBuildContext';
import { useUserContext } from '@context/UserContext';
import { PAGES } from '@services/routingService';
import { Loader } from '@sharedComponents/Loader';
import { EPage, ReactFCV } from '@types';

import { ILastOrder } from '../../../../model';
import { ORDER_AS_LAST_TIME_LOADER_SIZE } from '../../constants';

interface IParfumsHiddenFormProps {
  lastOrder: ILastOrder | null;
}

export const PafrumsHiddenForm: ReactFCV<IParfumsHiddenFormProps> = ({ lastOrder }) => {
  const {
    settings: { websiteHostAddress },
  } = useApplicationBuildContext();

  const {
    state: { isSubscribed: newsletter },
  } = useUserContext();

  const hiddenFormRef = useRef<HTMLFormElement | null>(null);

  useEffect(() => {
    if (hiddenFormRef.current) {
      hiddenFormRef.current?.submit();
    }
  }, []);

  if (!lastOrder) {
    return null;
  }

  return (
    <>
      <Loader height={ORDER_AS_LAST_TIME_LOADER_SIZE} />
      <form
        id="buyOnOneClick_form"
        action={`${websiteHostAddress}${PAGES[EPage.SUMMARY]?.external}`}
        method="post"
        ref={hiddenFormRef}>
        <input type="hidden" id="repeat-last-order" name="RepeatLastOrder" value="1" />
        <input type="hidden" id="react-validate-form" name="ReactValidateForm" value="1" />
        <input
          type="hidden"
          id="no-address-for-personal-pickup"
          name="NoAddressForPersonalPickup"
          value={Number(lastOrder.deliveryInfo.distributionPoint.noAddressForPersonalPickup)}
        />
        <input type="hidden" name="validate" value="1" />
        <input type="hidden" id="deliveryType" name="DeliveryType" value={lastOrder.deliveryInfo.deliveryTypeId} />
        <input type="hidden" id="paymentType" name="PaymentType" value={lastOrder.paymentInfo.paymentType} />
        <input type="hidden" id="invoice-phone" name="Phone" value={lastOrder.invoiceAddress.phone} />
        <input type="hidden" id="invoice-email" name="Email" value={lastOrder.invoiceAddress.email} />
        {newsletter && <input type="hidden" id="newsletter" name="contact-newsletter" value={Number(newsletter)} />}
        <input type="hidden" id="invoice-firstname" name="FirstName" value={lastOrder.invoiceAddress.firstName} />
        <input type="hidden" id="invoice-surname" name="LastName" value={lastOrder.invoiceAddress.lastName} />
        <input type="hidden" id="invoice-surname2" name="LastName2" value={lastOrder.invoiceAddress.secondName} />
        <input type="hidden" id="invoice-address" name="Street" value={lastOrder.invoiceAddress.street} />
        <input type="hidden" id="invoice-city" name="City" value={lastOrder.invoiceAddress.city} />
        <input type="hidden" id="invoice-zip" name="ZipCode" value={lastOrder.invoiceAddress.zipCode} />
        <input
          type="hidden"
          id="invoice-district-type"
          name="DistrictType"
          value={lastOrder.invoiceAddress.districtType ?? undefined}
        />

        <input
          type="hidden"
          id="company-identification-number"
          name="CompanyRegistrationNumber"
          value={lastOrder.invoiceAddress.companyIdentificationData?.companyRegistrationNumber}
        />
        <input
          type="hidden"
          id="personalIdentificationNumber"
          name="personal-identification-number"
          value={lastOrder.invoiceAddress.personalIdentificationNumber}
        />
        <input
          type="hidden"
          id="pec-code"
          name="pec-code"
          value={lastOrder.invoiceAddress.companyIdentificationData?.pecCode}
        />
        <input
          type="hidden"
          id="recipient-code"
          name="recipient-code"
          value={lastOrder.invoiceAddress.companyIdentificationData?.recipientCode}
        />

        <input type="hidden" id="invoice-floor" name="Floor" value={lastOrder.invoiceAddress.floor ?? undefined} />
        <input
          type="hidden"
          id="invoice-street-type"
          name="StreetType"
          value={lastOrder.invoiceAddress.streetType ?? undefined}
        />
        <input type="hidden" id="invoice-block" name="BlockNo" value={lastOrder.invoiceAddress.blockNo} />
        <input type="hidden" id="invoice-district" name="District" value={lastOrder.invoiceAddress.district} />
        <input type="hidden" id="invoice-entrance" name="Entrance" value={lastOrder.invoiceAddress.entrance} />
        <input type="hidden" id="invoice-flat" name="FlatNumber" value={lastOrder.invoiceAddress.flatNumber} />
        <input type="hidden" id="invoice-neigh" name="Neighborhood" value={lastOrder.invoiceAddress.neighborhood} />
        <input type="hidden" id="invoice-province" name="Province" value={lastOrder.invoiceAddress.province} />
        <input type="hidden" id="invoice-region" name="Region" value={lastOrder.invoiceAddress.region} />
        <input type="hidden" id="invoice-streetnum" name="StreetNumber" value={lastOrder.invoiceAddress.streetNumber} />
        <input type="hidden" id="invoice-note" name="Note" value={lastOrder.invoiceAddress.note} />
        {lastOrder.sameDeliveryAndInvoice ? (
          <input type="hidden" id="invoice-companyhack" name="FirmHack" value={lastOrder.deliveryAddress.company} />
        ) : (
          <>
            <input type="hidden" id="samedeliveryaddr" name="samedeliveryaddr" value="0" />
            <input type="hidden" id="delivery-firm" name="DeliveryFirm" value={lastOrder.deliveryAddress.company} />
          </>
        )}
        <input type="hidden" id="invoice-company" name="Firm" value={lastOrder.invoiceAddress.company} />
        <input type="hidden" id="company_rn" name="ICO" value={lastOrder.invoiceAddress.cin} />
        <input type="hidden" id="company_vatrn" name="DIC" value={lastOrder.invoiceAddress.tin} />
        <input type="hidden" name="jstest" value="1" />
        <input
          type="hidden"
          id="delivery-firstname"
          name="DeliveryFirstName"
          value={lastOrder.invoiceAddress.firstName}
        />
        <input type="hidden" id="delivery-lastname" name="DeliveryLastName" value={lastOrder.invoiceAddress.lastName} />
        <input
          type="hidden"
          id="delivery-lastname2"
          name="DeliveryLastName2"
          value={lastOrder.invoiceAddress.secondName}
        />
        <input type="hidden" id="delivery-street" name="DeliveryStreet" value={lastOrder.deliveryAddress.street} />
        <input type="hidden" id="delivery-city" name="DeliveryCity" value={lastOrder.deliveryAddress.city} />
        <input type="hidden" id="delivery-zip" name="DeliveryZipCode" value={lastOrder.deliveryAddress.zipCode} />
        <input type="hidden" id="delivery-region" name="DeliveryRegion" value={lastOrder.deliveryAddress.region} />
        <input
          type="hidden"
          id="delivery-district"
          name="DeliveryDistrict"
          value={lastOrder.deliveryAddress.district}
        />
        <input
          type="hidden"
          id="delivery-province"
          name="DeliveryProvince"
          value={lastOrder.deliveryAddress.province}
        />
        <input
          type="hidden"
          id="delivery-flat"
          name="DeliveryFlatNumber"
          value={lastOrder.deliveryAddress.flatNumber}
        />
        <input type="hidden" id="delivery-email" name="DeliveryEmail" value={lastOrder.deliveryAddress.email} />
        <input type="hidden" id="delivery-phone" name="DeliveryPhone" value={lastOrder.deliveryAddress.phone} />
        <input
          type="hidden"
          id="delivery-district-type"
          name="DeliveryDistrictType"
          value={lastOrder.deliveryAddress.districtType ?? undefined}
        />
        <input
          type="hidden"
          id="delivery-floor"
          name="DeliveryFloor"
          value={lastOrder.deliveryAddress.floor ?? undefined}
        />
        <input
          type="hidden"
          id="delivery-street-type"
          name="DeliveryStreetType"
          value={lastOrder.deliveryAddress.streetType ?? undefined}
        />
        <input
          type="hidden"
          id="delivery-streetnum"
          name="DeliveryStreetNumber"
          value={lastOrder.deliveryAddress.streetNumber}
        />
        <input type="hidden" id="delivery-block" name="DeliveryBlockNo" value={lastOrder.deliveryAddress.blockNo} />
        <input
          type="hidden"
          id="delivery-entrance"
          name="DeliveryEntrance"
          value={lastOrder.deliveryAddress.entrance}
        />
        <input
          type="hidden"
          id="delivery-neigh"
          name="DeliveryNeighborhood"
          value={lastOrder.deliveryAddress.neighborhood}
        />
        <input type="hidden" id="invoice-delivery-info" name="DeliveryInfo" value={lastOrder.deliveryAddress.info} />
        <input
          type="hidden"
          id="delivery-delivery-info"
          name="DeliveryDeliveryInfo"
          value={lastOrder.deliveryAddress.info}
        />
        <input
          type="hidden"
          id="distribution-point"
          name="distribution-point"
          value={lastOrder.deliveryInfo.distributionPoint.distributionPointId}
        />
      </form>
    </>
  );
};
